import { concat, fn, hash } from '@ember/helper';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-explorer';
import Table from 'umg-ember-backend/components/record-explorer/table';
import Toolbar from 'umg-ember-backend/components/record-explorer/toolbar';
import Pagination from 'umg-ember-backend/components/ui/pagination';
import Window from 'umg-ember-backend/components/ui/window';

export default class ListCompontensVhostComponent extends Component {
  // Defaults
  availableFilters = [
    {
      key: 'type',
      type: 'selectValueLabel',
      options: [
        'WP_VHOST',
        'REDIRECT',
        'WP_VHOST_PB_LARAVEL',
        'WP_VHOST_PB_NEXT',
        'CRM_VHOST',
        'CSAM_VHOST',
        'ECOM_VHOST',
        'PRODOPS_VHOST',
      ],
    },
  ];

  defaultColumns = [
    'id',
    'firstDomainName',
    'domains',
    'previewMlps',
    'type',
    'interpreter',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'firstDomainName',
      isMainColumn: true,
    },
    {
      property: 'domains',
      type: 'relation',
      isTruncate: true,
    },
    {
      property: 'previewMlps',
      type: 'relation',
      isTruncate: true,
    },
    {
      property: 'type',
      sortable: true,
      type: 'translate-value',
    },
    {
      property: 'interpreter',
      sortable: true,
      type: 'translate-value',
    },
    {
      property: 'redirect',
      sortable: true,
    },
  ];

  // Template
  // We need to overwrite the default template, because vhosts are not allowed to duplicate
  <template>
    <Window
      @isBottombarVisible={{if this.recordsData.length true false}}
      @isLoading={{this.loadRecords.isRunning}}
      @isSeamless={{true}}
      @onBodyScroll={{this.setScrollPosition}}
      @scrollPosition={{this.scrollPosition}}
      {{didInsert this.setOrLoadRecords}}
    >
      <:title>
        {{t (concat 'models.plurals.' this.recordType)}}
      </:title>

      <:toolbar>
        <Toolbar
          @activeColumns={{this.activeColumns}}
          @activeFilters={{this.activeFilters}}
          @availableFilters={{this.availableFilters}}
          @columns={{this.tableColumns}}
          @recordType={{this.recordType}}
          @onAddRecord={{this.addRecord}}
          @onAssignRelation={{@onAssignRelation}}
          @onSearch={{this.search}}
          @onSetFilter={{this.setFilter}}
          @parentRecordType={{@parentRecordType}}
          @searchString={{this.searchString}}
          @selectedRecords={{this.selectedRecords}}
        />
      </:toolbar>

      <:body>
        <Table
          @activeSort={{this.activeSort}}
          @columns={{this.visibleColumns}}
          @records={{this.recordsData}}
          @recordType={{this.recordType}}
          @recordActions={{hash edit=this.loadRecord delete=this.deleteRecord}}
          @selectedRecords={{this.selectedRecords}}
          @onAssignRelation={{@onAssignRelation}}
          @onUpdateSort={{fn this.setFilter 'sort'}}
          @onSelectRecord={{this.selectRecord}}
        />
      </:body>

      <:bottombar>
        <Pagination
          @pagination={{this.records.meta}}
          @setPage={{this.setPage}}
          @setPageLimit={{fn this.setFilter 'pageSize'}}
        />
      </:bottombar>
    </Window>
  </template>
}
